import api from '@pray/shared/utils/api';

import type { SmsAnalytics } from './types';

type GetSmsAnalyticsProps = {
  artistId: string;
  startDate?: string;
  endDate?: string;
};

export async function getSmsAnalytics({ artistId, startDate, endDate }: GetSmsAnalyticsProps) {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/sms-config/analytics`;

  const params: Record<string, string> = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;

  const response = await api.executeGetRequest<{ data: SmsAnalytics }>(url, params);

  return response.data;
}
